/**
 *
 *  プロジェクト固有のユーティリティ関数を定義します
 *
 */

import * as util from "./util.js";
import { extractAddrSpecForMailValidation, isWellFormedMailAddress } from "./mailAddressValidation.js";
import { requestPostMailsubOdrdZaikoKaito } from "./postMailsubOdrdZaikoKaito.js";

export { extractAddrSpecForMailValidation, isWellFormedMailAddress, requestPostMailsubOdrdZaikoKaito };

export const utils = {
  ...util,
  extractAddrSpecForMailValidation,
  isWellFormedMailAddress,
  requestPostMailsubOdrdZaikoKaito,
};
